<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-boxes"></i> ตั้งค่าหมวดหมู่สินค้า</h4>

          <div class="row mx-1 my-3">
            <b-form-input
              type="search"
              class="col"
              autofocus
              v-model="filter"
              placeholder="ค้นหาหมวดหมู่สินค้า จากรหัส หรือชื่อหมวดหมู่"
            ></b-form-input>
            <b-button
              class="col-5 col-sm-4 col-md-3 ml-3"
              variant="primary"
              @click="openCatagoryItemModal()"
            >
              <i class="fas fa-plus"></i> เพิ่มรายการ
            </b-button>
          </div>

          <b-table
            id="catagoryManageTable"
            ref="catagoryManageTable"
            hover
            small
            sort-icon-left
            head-variant="light"
            :items="getCatagoryList"
            :fields="fields"
            :filter="filter"
            sort-by="creationDt"
            :sort-desc="true"
            :responsive="true"
          >
            <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
            <template v-slot:cell(creationDt)="row">{{
              formatDate(row.item.creationDt)
            }}</template>
            <template v-slot:cell(buttons)="row">
              <b-button-group
                v-if="row.item.catagoryStatus === 'ACTIVE'"
                class="show-when-hovered"
                size="xs"
              >
                <b-button
                  variant="outline-secondary"
                  @click="editCatagory(row.item)"
                >
                  <i class="fas fa-edit"></i>
                </b-button>
                <b-button
                  variant="outline-danger"
                  @click="deleteCatagory(row.item)"
                >
                  <i class="fas fa-trash-alt"></i>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
        </div>
      </div>
      <CatagoryItem ref="catagoryItemModal"></CatagoryItem>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import CatagoryItem from "../../components/modal/ProductAndStock/CategoryItem.vue";
import Dialog from "../../components/modal/Dialog.vue";
import Loading from "@/components/Loading";

export default {
  name: "CategoryMaster",
  components: {
    CatagoryItem,
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fields: [
        {
          key: "index",
          label: "",
        },
        {
          key: "catagoryCode",
          label: "รหัส",
          sortable: true,
        },
        {
          key: "catagoryNameTh",
          label: "ชื่อหมวดหมู่",
          sortable: true,
        },
        {
          key: "catagoryNameEn",
          label: "ชื่อหมวดหมู่ (Eng)",
          sortable: true,
        },
        {
          key: "creationDt",
          label: "วันที่สร้าง",
          sortable: true,
        },
        {
          key: "buttons",
          label: "",
          class: "text-center",
        },
      ],
      filter: null,
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      getCatagoryList: "moduleCatagoryMaster/getCatagoryList",
    }),
  },
  methods: {
    ...mapActions({
      fetchCatagoryList: "moduleCatagoryMaster/fetchCatagoryList",
    }),
    async init() {
      this.isLoading = true;
      try {
        await this.fetchCatagoryList({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
        });
      } catch (err) {
        this.showDialogToast("danger", "โหลดหมวดหมู่สินค้าไม่สำเร็จ");
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    formatDate(date) {
      if (date) {
        return moment(date).locale("th").format("D MMM YY");
      } else {
        return "";
      }
    },
    openCatagoryItemModal(catagory = null) {
      this.$refs.catagoryItemModal.show(catagory);
    },
    editCatagory(catagory) {
      this.openCatagoryItemModal(catagory);
    },
    deleteCatagory(eventData) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบหมวดหมู่สินค้านี้ ?",
        "คุณต้องการลบหมวดหมู่สินค้านี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;
        this.$store
          .dispatch("moduleCatagoryMaster/deleteCatagoryItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            id: eventData.catagoryId,
          })
          .then(res => {
            if (res.status == 200) {
              this.init();
              this.showDialogToast("success", "ลบรายการหมวดหมู่สินค้าสำเร็จ");
            }
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ลบรายการหมวดหมู่สินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
  },
};
</script>

<style scoped></style>
